import Scroll from "react-scroll";

export const scrollToTileById = (tileId: string = "your-tile") => {
  Scroll.scroller.scrollTo(tileId, {
    duration: 500,
    offset: -150,
    smooth: true,
  });
};
